import Gamepad from "./Gamepad";

export default Gamepad;